// extracted by mini-css-extract-plugin
export default {"shareIcon":"copy-to-clipboard_shareIcon__UjRZ9","shareIconWrap":"copy-to-clipboard_shareIconWrap__BbINe","popup":"copy-to-clipboard_popup__JDHDy"};